import React from 'react'
import { Icon } from '@chakra-ui/react'

export function IconTrash(rest) {
  return (
    <Icon viewBox="0 0 16 16" {...rest}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3,13.3333333 C3,14.1481481 4.02222222,15 5,15 L11,15 C11.9777778,15 13,14.1481481 13,13.3333333 L13,5 L3,5 L3,13.3333333 Z M14,2 L11,2 L10.4444444,1 L6,1 L5,2 L2,2 L2,4 L14,4 L14,2 Z"
      />
    </Icon>
  )
}
